<aslib-title Text="Consolidação Municípios - SIGAT" SubText="Consulta" ></aslib-title>

<form novalidate [formGroup]='formConsultaIpva'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Data de geração das informações no SIGAT a partir de:</label>
    <div class="controls col-md-2">
      <input type="date" [(ngModel)]="DataInicio" required  formControlName="DataInicio" class="form-control">
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-4 offset-md-3">
      <button type="submit" class="btn btn-primary" [disabled]="!formConsultaIpva.valid" (click)="consultarDadosIPVA(modalMensagem)" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Aplicar Filtro </button>
    <button type="submit" class="btn btn-primary" (click)="limparConsulta()" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Limpar </button>
    </div>
    
  </div>

</form>


<div class="form-group row mb-5" *ngIf="exibirGrid" >
  
  <aslib-grid id="as-grid" class="col-md-12" [(dataset)]="_dadosConciliacao.ListaConciliacaoDistribuicao" [pagination]="true">
    
    <aslib-grid-column [property]="'CodigoMunicipio'" [header]="'Código do Município'" [width]="60" [sortable]="true"></aslib-grid-column>
    <aslib-grid-column [property]="'Municipio'" [header]="'Município'" [width]="100" [sortable]="true"></aslib-grid-column>
    <aslib-grid-column [property]="'UnidadeFederacao'" [header]="'Sigla'" [width]="30" [sortable]="true"></aslib-grid-column>

    <aslib-grid-column [property]="'DataPagamento'"  [width]="60" [header]="'Data de Pagamento'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ item.DataPagamento | date : 'dd/MM/yyyy'}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'DataAtualizacao'"  [width]="60" [header]="'Data de Atualização'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ item.DataAtualizacao | date : 'dd/MM/yyyy'}}</span>
      </ng-template>
    </aslib-grid-column>
<aslib-grid-column [property]="'Nsa'" [header]="'NSA'" [width]="30" [sortable]="true"></aslib-grid-column>
    <aslib-grid-column [property]="'ValorTotal'"  [width]="50" [header]="'Valor Total'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ item.ValorTotal | currency:'BRL'}}</span>
      </ng-template>
    </aslib-grid-column>

     <aslib-grid-column [property]="'ValorTotalOriginal'"  [width]="60" [header]="'Valor Total Original'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ item.ValorTotalOriginal | currency:'BRL'}}</span>
      </ng-template>
    </aslib-grid-column>

  </aslib-grid>
</div>
  <div class="form-group row"  *ngIf="exibirGrid">
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary" (click)="gerarRelatorio(1)" [disabled]="!formConsultaIpva.valid" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Excel
      </button>
    </div>
  </div>

<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/ipva/consulta-ipva/consulta-ipva.component.html